/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { UpdatePartnerCreatorResponse, UpdatePartnerCreatorVars } from '../openapi-types.gen.js';

export type { UpdatePartnerCreatorResponse, UpdatePartnerCreatorVars } from '../openapi-types.gen.js';

export const useUpdatePartnerCreator = createMutationHook<UpdatePartnerCreatorVars, UpdatePartnerCreatorResponse, unknown>({
  specName: 'useUpdatePartnerCreator',
  path: '/v1/admin/creators/{id}',
  method: 'PUT',
  resolveUrl: (vars: UpdatePartnerCreatorVars) => `/v1/admin/creators/${vars.id}`,
  buildBody: (vars: UpdatePartnerCreatorVars) => ({ displayName: vars.displayName, handle: vars.handle, avatarUrl: vars.avatarUrl, bannerUrl: vars.bannerUrl, bio: vars.bio, introduction: vars.introduction, website: vars.website, location: vars.location, categories: vars.categories, socialLinks: vars.socialLinks, videoUrl: vars.videoUrl, videoStorageKey: vars.videoStorageKey }),
  parseResponse: (raw: unknown): UpdatePartnerCreatorResponse => raw as UpdatePartnerCreatorResponse,
  optimistic: [{
    queryKey: ['admin', 'partner-creators'],
    apply: (prev: any, vars: UpdatePartnerCreatorVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }, {
    queryKey: ['admin', 'partner-creator'],
    apply: (prev: any, vars: UpdatePartnerCreatorVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
